'use client';

import useUser from 'components/hooks/use-user';
import { logout } from 'components/login/actions';
import { useEffect } from 'react';

export default function AutoLogoutGuest() {
    const { user, mutate } = useUser();
    // Make sure guest users aren't logged in to their guest account on the storefront.
    useEffect(() => {
        const logoutGuest = async () => {
            const result = await logout();
            if (result && result.isSuccess) {
                console.debug('logged out guest user');
                mutate();
            } else {
                console.error(result.error);
            }
        }
        if (user?.isNewGuest) {
            logoutGuest();
        }
    }, [user?.isNewGuest, mutate]);
    return null;
}
